import React from "react";
import Nabvar from "../common/Nabvar";
import Sidebar from "../common/Sidebar";
import Order from "./coupon/Order";

export default function CouponList() {

  return (
    <>
      <Sidebar />
      <Nabvar />
      <Order />
    </>
  );
}
